export default __webpack_public_path__ + "static/media/3.0b54e0e2.png";